import { HTMLAttributes } from "react";

import { SpinnerLineStyled } from "./index.styled";
import { ReactComponent as SpinnerDashSVG } from "./Spinner.svg";

export function SpinnerLine(props: HTMLAttributes<HTMLDivElement>) {
  return <SpinnerLineStyled data-testid="qa-spinner-line" {...props} />;
}

export function SpinnerDash(props: HTMLAttributes<HTMLSpanElement>) {
  return (
    <div data-testid="qa-spinner-dash" className="u-inline-block u-text-neutral_secondary_text" {...props}>
      <SpinnerDashSVG className="u-animate-spin" />
    </div>
  );
}
